import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/Dashboard/Parent/Header";
import AIAnalysisNavigation from "../../../components/Dashboard/Parent/AIAnalysisNavigation";
import AIAnalysisContent from "../../../components/Dashboard/Parent/AIAnalysisContent";
import toast from "react-hot-toast";
import { getUserById } from "../../../services/operations/authAPI";
import { useTranslation } from "react-i18next";
import { getStudentFees } from "../../../services/operations/studentFeesAPI"; // Import fee service

export default function Parent() {
  const { i18n, t } = useTranslation();
  const toastShown = useRef(false); // Ref to ensure toast only shows once per mount
  const [activeAISection, setActiveAISection] = useState("overview");
  const { user } = useSelector((state) => state.profile);
  const [aiReport, setAiReport] = useState(user?.ai_insight_report || null);
  const dispatch = useDispatch();
  const [linkedUser, setLinkedUser] = useState();
  const [feesData, setFeesData] = useState(null);

  // 1. Fetch the child's data
  useEffect(() => {
    const fetchLinkedUser = async () => {
      if (user.role === "parent" && user.children?.length > 0) {
        const User = await dispatch(getUserById(user.children[0]));
        setLinkedUser(User);
      } else if (user.parents?.length > 0) {
        const User = await dispatch(getUserById(user.parents[0]));
        setLinkedUser(User);
      }
    };
    fetchLinkedUser();
  }, [user, dispatch]);

  // 2. Fetch Fees and Check for Overdue Installments
  useEffect(() => {
    const checkFeesAndToast = async () => {
      // Only run if we have a linkedUser (the student)
      if (linkedUser && linkedUser.role === "student") {
        try {
          const response = await getStudentFees(linkedUser._id);
          if (response?.list && response.list.length > 0) {
            const currentFees = response.list[0]; // Get latest academic year
            setFeesData(currentFees);

            // Toast Logic
            if (!toastShown.current) {
              const now = Date.now();
              
              // Filter for overdue installments
              const overdueInstallments = currentFees.installments?.filter((inst) => {
                const dueDate = new Date(inst.dueDate).getTime();
                const isNotCompleted = inst.status !== "COMPLETED";
                const isPastDue = dueDate < now;
                
                return isNotCompleted && isPastDue;
              });

              if (overdueInstallments?.length > 0) {
                toast.error(
                  `OverdueAlert: ${overdueInstallments.length} installment(s) pending for ${linkedUser.name}`,
                  { duration: 10000, position: "top-center" }
                );
              }
              toastShown.current = true; // Mark as shown
            }
          }
        } catch (error) {
          console.error("Error fetching fees for toast check:", error);
        }
      }
    };

    checkFeesAndToast();
  }, [linkedUser, t]);

  // 3. AI Report Language Handling
  useEffect(() => {
    if (!user) {
      setAiReport([]);
      return;
    }
    if (i18n.language.startsWith("te")) {
      setAiReport(user.ai_insights_telugu || []);
    } else {
      setAiReport(user.ai_insight_report || []);
    }
  }, [user, i18n.language]);

  return (
    <div className="min-h-screen font-sans text-slate-800">
      <div className="container mx-auto p-4 sm:p-6 lg:p-8">
        <Header />
        <main className="mt-6">
          <div className="mt-6">
            <AIAnalysisNavigation
              activeSection={activeAISection}
              setActiveSection={setActiveAISection}
              report={aiReport}
            />
            <AIAnalysisContent
              activeSection={activeAISection}
              report={aiReport}
              linkedUser={linkedUser}
              feesData={feesData} // Passing fetched fees down
            />
          </div>
        </main>
      </div>
    </div>
  );
}